import { render, staticRenderFns } from "./mdProductList.vue?vue&type=template&id=0843b85c&scoped=true&"
import script from "./mdProductList.vue?vue&type=script&lang=js&"
export * from "./mdProductList.vue?vue&type=script&lang=js&"
import style0 from "./mdProductList.vue?vue&type=style&index=0&id=0843b85c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0843b85c",
  null
  
)

export default component.exports